import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, ValidateNested, IsString } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

import { DetailPolicyVersion } from './detail-policy-version.dto';

export class AcceptCryptoLocalDto {
  @Type(() => DetailPolicyVersion)
  @ValidateNested({ each: true })
  @IsArray()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  policyVersions: DetailPolicyVersion[];

  @IsString()
  @IsNotEmpty()
  certificateId: string;
}
